module.exports = __webpack_public_path__ + "assets/img/tag_list-8f99d33f.png";